"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortAndFilterTracks = sortAndFilterTracks;
function sortAndFilterTracks(combinedTracks) {
    // Find the best audio track, remove all tracks with lower audio qualities
    var audioBandwidths = combinedTracks.map(function (t) { return t.audioTrack.bandwidth; });
    var bestAudioBandwidth = Math.max.apply(Math, audioBandwidths);
    var tracksWithBestAudioQuality = combinedTracks.filter(function (t) { return t.audioTrack.bandwidth === bestAudioBandwidth; });
    // Sort the tracks by the combined bandwidth - Ascending
    var sortedTracks = tracksWithBestAudioQuality.sort(function (a, z) { return a.combinedBandwidth - z.combinedBandwidth; });
    return sortedTracks;
}
